<template>
  <v-row>
    <v-col cols="12">
      <v-data-table
          class="sm-font400-13 textTable--text"
          :headers="headers"
          :items="categoryItems"
          hide-default-footer
          no-results-text="دیتایی وجود ندارد!"
          :loading="loading"
          loading-text="Loading..."
          item-key="id"
          show-select
          v-model="idList"
          @input="updateIds"
      >
        <template v-slot:[`item.is_active`]="{ item }">
          <v-switch :input-value="item.is_active" @click="showToggleStatusById(item)" inset readonly></v-switch>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn @click="showDeleteItem(item)" icon>
            <img src="@/assets/Icon/Table/trash.svg" alt="">
          </v-btn>
          <v-btn @click="showArchiveItem(item)" icon>
            <img src="@/assets/Icon/Table/archive-tick.svg" alt="">
          </v-btn>
          <v-btn @click="showEditItem(item)" icon>
            <img src="@/assets/Icon/Table/edit-2.svg" alt="">
          </v-btn>
        </template>
      </v-data-table>
    </v-col>
    <v-col cols="12">
      <v-pagination
          v-model="filterSearch.page"
          :length="totalPages"
          @input="changePage"
          color="thirdColor"
      ></v-pagination>
    </v-col>


    <v-dialog v-model="showToggleById" width="500">
      <v-card class="pa-10  text-center rounded-xl">
        <h3 class="mb-5">آیا از فعال/غیرفعال کردن دوره ویتک مطمئن هستید؟</h3>
        <v-btn @click="showToggleById = false" elevation="0"
               class="black--text border rounded-lg mt-3 me-4" height="32">بازگشت
        </v-btn>
        <v-btn :loading="loading" elevation="0" @click="confirmToggleStatusById" color="primary"
               class="white--text rounded-lg mt-3" height="32">فعال/غیرفعال کردن
        </v-btn>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showArchive" width="500">
      <v-card class="pa-10  text-center rounded-xl">
        <h3 class="mb-5">آیا از آرشیو دسته بندی {{ updatingItem.title }} مطمئن هستید؟</h3>
        <v-btn @click="showArchive = false" elevation="0"
               class="black--text border rounded-lg mt-3 me-4" height="32">بازگشت
        </v-btn>
        <v-btn :loading="loadingArchive" elevation="0" @click="confirmArchive" color="secondary"
               class="white--text rounded-lg mt-3" height="32">آرشیو کردن
        </v-btn>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDelete" width="500">
      <v-card class="pa-10  text-center rounded-xl">
        <h3 class="mb-5">آیا از حذف دسته بندی {{ updatingItem.title }} مطمئن هستید؟</h3>
        <div class="text-center">
          <v-btn width="130" height="48" color="gray" outlined class="me-2 rounded-xl" @click="showDelete = false">
            بازگشت
          </v-btn>
          <v-btn @click="confirmDelete" :loading="loadingDelete" width="130" height="48" class="white--text rounded-xl" color="nagative">حذف
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showAddCategory" width="850">
      <v-card class="pa-10 rounded-xl">
        <div class="d-flex align-center justify-space-between mb-7">
<!--          <v-icon class="me-3">mdi-arrow-right</v-icon>-->
          <p class="mb-0 sm-font600-16 textColorSecond--text">ویرایش دسته بندی</p>
          <v-btn icon @click="showAddCategory = false" aria-label="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-form>
          <v-row>
            <v-col class="py-1" md="6" cols="12">
              <label>عنوان دسته بندی</label>
              <v-text-field
                  v-model="updatingItem.title"
                  class="rounded-lg mt-1 pr-0 sm-font400-14"
                  solo
                  single-line
                  hide-details
              ></v-text-field>
            </v-col>
            <v-col class="py-1" cols="12" md="6">
              <label>تصویر دسته بندی</label>
              <v-file-input
                  v-model="updatingItem.image"
                  accept="image/*"
                  prepend-icon=""
                  append-icon="mdi-upload"
                  class="rounded-lg mt-2 sm-font400-14"
                  solo
                  hide-details
                  @change="changedImage"
              >
                <template slot="prepend-inner" v-if="imagePreview">
                  <a target="_blank" :href="imagePreview" class="d-flex align-center">
                    <v-avatar size="32" class="me-2">
                      <v-img :src="imagePreview" />
                    </v-avatar>
                    <span class="sm-font400-12">پیش‌نمایش</span>
                  </a>
                </template>
              </v-file-input>
        
            </v-col>
            <v-col class="py-1" cols="12" md="6">
              <label>بارگزاری فایل توضیحات دوره</label>
              <v-file-input v-model="updatingItem.description_file" prepend-icon="" append-icon="mdi-upload"
                            class="rounded-lg mt-2 sm-font400-14" solo hide-details  @change="changedFile">
                <template slot="prepend-inner" v-if="filePreview !== '' && showFilePreview">
                  <a target="_blank" :href="filePreview">file</a>
                </template>
              </v-file-input>
            </v-col>
            <v-col cols="12">
              <label>توضیحات</label>
              <v-textarea v-model="updatingItem.description" class="rounded-lg mt-2 sm-font400-14" rows="3" hide-details
                          solo></v-textarea>
            </v-col>
            <v-col cols="12" class="d-flex justify-end">
              <v-btn
                  color="positive"
                  class="textColor--text sm-font500-16 rounded-xl me-3"
                  depressed
                  height="48"
                  width="230"
                  :loading="loadingUpdate"
                  @click="submitEditCategory"
              >
                بروزرسانی اطلاعات
              </v-btn>

              <v-btn width="230" height="48" depressed color="nagative"
                     class="textColor--text sm-font500-16 rounded-xl" @click="showAddCategory = false">
                انصراف
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import courseApi from "@/Services/modules/courses"

export default {
  name: "data-table",
  props: {
    categoryItems: {
      type: Array
    },
    loading: {
      type: Boolean
    },
    ids: {
      type: Array
    },
    totalPages: {
      type: Number
    },
  },
  data() {
    return {
      loadingUpdate: false,
      loadingDelete: false,
      loadingArchive: false,
      
      imagePreview: "",
      imageObjectUrl: "",
      filePreview: "",
      showImagePreview: false,
      showFilePreview: false,
      idList: this.ids,
      showToggleById: false,
      showArchive: false,
      showDelete: false,
      showAddCategory: false,
      headers: [
        {text: "عنوان دسته بندی", value: "title", align: 'center'},
        {text: "تعداد دوره‌های مادر متصل", value: "base_courses_count", align: 'center'},
        {text: "فعال/غیرفعال", value: "is_active", align: 'center'},
        {text: "عملیات", value: "actions", align: "center", width: "300",},
      ],
      updatingItem: {},
      filterSearch: {
        page: Number(this.$route.query.page) || 1
      }
    }
  },
  methods: {
    showToggleStatusById(item) {
      this.updatingItem = item
      this.showToggleById = true
    },
    showDeleteItem(item) {
      this.showDelete = true
      this.updatingItem = item
    },
    showArchiveItem(item) {
      this.showArchive = true
      this.updatingItem = item
    },
    showEditItem(item) {
      this.showAddCategory = true
      this.updatingItem = item
      this.imagePreview = this.updatingItem.image
      this.filePreview = this.updatingItem.description_file
      if (this.imagePreview !== "" && this.imagePreview !== null) {
        this.showImagePreview= true
      }
      if (this.filePreview !== "" && this.filePreview !== null) {
        this.showFilePreview= true
      }
      // Backward compatibility: if backend still provides a `video` field, don't send it back on edit.
      delete this.updatingItem.video
      delete this.updatingItem.description_file
      delete this.updatingItem.image
    },
    changedImage(file) {
      // If user selects a new local file, show a true preview (blob URL).
      // If they clear the selection, hide the preview.
      try {
        if (this.imageObjectUrl) URL.revokeObjectURL(this.imageObjectUrl)
      } catch (e) {
        // ignore
      } finally {
        this.imageObjectUrl = ""
      }

      if (!file) {
        this.imagePreview = ""
        this.showImagePreview = false
        return
      }

      const selected = Array.isArray(file) ? file[0] : file
      if (selected instanceof File) {
        this.imageObjectUrl = URL.createObjectURL(selected)
        this.imagePreview = this.imageObjectUrl
        this.showImagePreview = true
        return
      }

      // Fallback: if it's already a URL string
      if (typeof selected === "string") {
        this.imagePreview = selected
        this.showImagePreview = true
      }
    },
    changedFile() {
      this.showFilePreview = false
    },
    confirmToggleStatusById() {
      courseApi.singleStatusActionOnCategory(this.updatingItem).finally(() => {
        this.showToggleById = false
        this.$emit("getData")
      })
    },
    confirmArchive() {
      this.loadingArchive = true
      let data = {
        course_category_ids: [this.updatingItem.id],
        is_archive: true
      }
      courseApi.archiveCategory(data).finally(() => {
        this.showArchive = false
        this.$emit("getData", {...this.$route.query, is_archive: false})
      }).finally(()=> {
        this.loadingArchive = false
      })
    },
    confirmDelete() {
      this.loadingDelete = true
      courseApi.deleteCategory(this.updatingItem.id).finally(() => {
        this.showDelete = false
        this.$emit("getData",{...this.$route.query, is_archive: false})
      }).finally(() => {
        this.loadingDelete = false
      })
    },
    changePage() {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: this.filterSearch.page
        }
      })
      this.$emit("getData", {...this.$route.query, is_archive: false})
    },
    updateIds() {
      let ids = this.idList.map(item => item.id)
      this.$emit('updateIds', ids)
    },
    submitEditCategory() {
      this.loadingUpdate =true
      // Always send فعال to api
      this.updatingItem.is_active = true
      courseApi.editCategory(this.updatingItem)
        .then(()=> {
          this.$emit("getData", {...this.$route.query, is_archive: false})
        })
        .finally(()=> {
          this.showAddCategory = false
          this.updatingItem = {}
          this.loadingUpdate  = false
        })
    }
  },
  beforeDestroy() {
    try {
      if (this.imageObjectUrl) URL.revokeObjectURL(this.imageObjectUrl)
    } catch (e) {
      // ignore
    }
  }
}
</script>

<style scoped>

</style>
